<template>
  <div class="header-title">
    <p>营口市艾滋病干预 后台管理程序</p>
    <div class="exit-btn" @click="_logOut">退出</div>
  </div>
</template>

<script>
/* eslint-disable */
import { ElMessageBox, ElMessage } from 'element-plus'
import { logout } from '@/api/index'
import { loginStatus } from '@/api/index'
import http from '@/util/http'
import Cookies from 'js-cookie'
import { timestampToDate } from '@/util/timeToTranser'

export default {
  name: 'headerTitle',
  mounted() {
    this._loginStatus()
    this._insNumCount()
    this._getTimestamp()
  },
  methods: {
    _logOut() {
      ElMessageBox.confirm('确定要退出后台管理程序？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logout().then((res) => {
            if (res.code == 200) {
              this.$router.push({
                path: '/login'
              })
            }
          })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {
          console.log('取消退出')
        })
    },
    _loginStatus() {
      loginStatus().then(res => {
        if (res.code === 200) {
          // 已登录
          // ElMessage.success("已登录")
        } else {
          // 尚未登录
          ElMessage.warning('请先登录')
        }
      })
    },
    _insNumCount() {
      http.get('insNumCount/').then((res) => {
        if (res.code == 200) {
          console.log(res);
        }
      })
    },
    _getTimestamp() {
      http.get('timestamp/').then(res => {
        if (res.code === 200) {
          Cookies.set('startTime', timestampToDate(res.data.firstDay, 1))
          Cookies.set('nowTime', timestampToDate(res.data.now, 1))
        }
      })
    }
  }
}
</script>

<style scoped>
.header-title {
  display: flex;
  width: 100%;
  height: 80px;
  background-color: #007bff;
  align-items: center;
  justify-content: space-between;
}

.header-title p {
  color: #fff;
  font-size: 25px;
  font-weight: bold;
  margin-left: 50px;
}

.exit-btn {
  color: #f2f2f2;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
}
</style>
